import { isAxiosError } from 'axios';

/** Notification 429 investigation (2026-11-03): a rate-limited request is
 * never retried straight away (that only spends more of the budget), and
 * polls wait at least as long as the server's Retry-After before trying
 * again. */
export const isRateLimited = (error: unknown) =>
  isAxiosError(error) && error.response?.status === 429;

/** The server's Retry-After (header, or `retryAfterSeconds` in the body), in ms. */
export const retryAfterMs = (error: unknown): number | null => {
  if (!isAxiosError(error)) return null;
  const header = Number(error.response?.headers?.['retry-after']);
  const body = Number(
    (error.response?.data as { retryAfterSeconds?: unknown } | undefined)?.retryAfterSeconds,
  );
  const seconds =
    Number.isFinite(header) && header > 0
      ? header
      : Number.isFinite(body) && body > 0
        ? body
        : null;
  return seconds == null ? null : seconds * 1000;
};

/** React Query `retry`: once for ordinary failures, never for a 429. */
export const retryUnlessRateLimited = (failureCount: number, error: unknown) =>
  !isRateLimited(error) && failureCount < 1;

/** A poll's next interval: the usual one, or longer while rate-limited. */
export const pollInterval = (intervalMs: number, error: unknown) =>
  isRateLimited(error) ? Math.max(intervalMs, retryAfterMs(error) ?? intervalMs) : intervalMs;
